import React, { useState } from 'react';
import "./Discount.css";
import useAuth from '../../customHooks/useAuth';
import Header from '../components/Header';

import TokenCard from './TokenCard';
import TokenModal from './TokenModal';

export default function Discount() {
    useAuth();
    // const [activeToken,setActiveTokens] = useState("availableTokens");

    const [isModalOpen, setIsModalOpen] = useState(false);

    const tokensData = [
        {
            bookingId : "a1",
            requests : 4,
            tokens : 4,
            discount : 20,
            date : "2021-09-21",
        },
        {
            bookingId : "a1",
            requests : 4,
            tokens : 4,
            discount : 20,
            date : "2021-09-21",
        },
        {
            bookingId : "a1",
            requests : 4,
            tokens : 4,
            discount : 20,
            date : "2021-09-21",
        },
        {
            bookingId : "a1",
            requests : 4,
            tokens : 4,
            discount : 20,
            date : "2021-09-21",
        },
        {
            bookingId : "a1",
            requests : 4,
            tokens : 4,
            discount : 20,
            date : "2021-09-21",
        }
    
    ]

    return (
    <>
        <div className='discount-main'>
            <Header title ="Alfred Tokens" 
                para = "Unlock discounts with Alfred tokens on requests."
            />
            
            {/* Filter Options */}
            {/* <div className='filter-discounts'>
                <div className={`token-option ${activeToken==="availableTokens" ? "active" : ""}`} onClick={()=>setActiveTokens("availableTokens")}>
                    Available Tokens
                </div>
                <div className={`token-option ${activeToken==="utilizedTokens" ? "active" : ""}`} onClick={()=>setActiveTokens("utilizedTokens")}>
                    Utillized Tokens
                </div>
            </div> */}

            {/* Tokens Data */}
            <div className='tokens-data'>

                {
                    tokensData.map((item,index)=>{
                        return(
                            <TokenCard key={index} setIsModalOpen={setIsModalOpen}/>
                        )

                    })
                }

            </div>

            <div className='token-usage'>
                <div className='token-usage-details'>
                    <h4>Available Tokens : </h4>
                    <h4>34</h4>
                </div>
                <div className='token-usage-btn'>
                    <button>
                        Redeem Tokens
                    </button>
                </div>
            </div>

        </div>
        {
            isModalOpen &&  <TokenModal setIsModalOpen={setIsModalOpen}/>
        }
    </>
  )
}
